module.exports = __webpack_public_path__ + "static/media/google.ff57e31a.png";